export const environment = {
  production: true,
  apiUrl : './API',
  ructUrl: 'https://ws262.juntadeandalucia.es/ruct',
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts